import React from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import Home from './Home';
import AboutUs from './AboutUs';
import OurTeam from './OurTeam';
import Services from './Services';
import Contact from './Contact';
import Overseas from './Overseas';
import Internships from './Internships';
import NewOffice from './NewOffice';
import Articles from './Articles';
import logoImg from './assets/images/website-logo.png';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <div className="announcement-bar">
          <span>Personalized legal counsel for individuals, families, and corporations across Pakistan.</span>
          <a href="https://wa.me/923343161042" target="_blank" rel="noopener noreferrer">
            WhatsApp Consultation
          </a>
        </div>
        <header className="App-header">
          <div className="header-top">
            <div className="brand-row">
              <img src={logoImg} alt="Irfan Haroon & Associates" className="brand-logo" />
              <div>
                <p className="brand-label">Irfan Haroon &amp; Associates</p>
                <p className="brand-subtitle">Advocates &amp; Legal Consultants — Supreme Court &amp; High Courts</p>
              </div>
            </div>
            <div className="header-cta">
              <div className="cta-phones">
                <span className="cta-label">Immediate Help</span>
                <a href="tel:+923343161041" className="cta-number">+92 334 316 1041</a>
                <a href="tel:+923343161042" className="cta-number">+92 334 316 1042</a>
              </div>
              <a href="https://wa.me/923343161042" className="button button-small" target="_blank" rel="noopener noreferrer">
                Book a Meeting
              </a>
            </div>
          </div>
          <div className="header-nav">
            <nav className="main-nav">
              <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : '')}>Home</NavLink>
              <NavLink to="/about" className={({ isActive }) => (isActive ? 'active' : '')}>About</NavLink>
              <NavLink to="/team" className={({ isActive }) => (isActive ? 'active' : '')}>Our Team</NavLink>
              <NavLink to="/services" className={({ isActive }) => (isActive ? 'active' : '')}>Practice Areas</NavLink>
              <NavLink to="/overseas" className={({ isActive }) => (isActive ? 'active' : '')}>Overseas Clients</NavLink>
              <NavLink to="/internships" className={({ isActive }) => (isActive ? 'active' : '')}>Internships</NavLink>
              <NavLink to="/new-office" className={({ isActive }) => (isActive ? 'active' : '')}>New Office</NavLink>
              <NavLink to="/articles" className={({ isActive }) => (isActive ? 'active' : '')}>Articles</NavLink>
              <NavLink to="/contact" className={({ isActive }) => (isActive ? 'active' : '')}>Contact</NavLink>
            </nav>
          </div>
        </header>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/team" element={<OurTeam />} />
          <Route path="/internships" element={<Internships />} />
          <Route path="/new-office" element={<NewOffice />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/services" element={<Services />} />
          <Route path="/overseas" element={<Overseas />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <footer>
          <div className="footer-inner">
            <div className="footer-brand">
              <img src={logoImg} alt="Irfan Haroon & Associates" className="footer-logo" />
              <p className="footer-firm">Irfan Haroon &amp; Associates</p>
              <p className="footer-tagline">Advocates &amp; Legal Consultants<br />Supreme Court &amp; High Courts</p>
            </div>
            <div className="footer-col">
              <p className="footer-heading">Navigate</p>
              <nav className="footer-nav">
                <NavLink to="/">Home</NavLink>
                <NavLink to="/about">About</NavLink>
                <NavLink to="/team">Our Team</NavLink>
                <NavLink to="/services">Practice Areas</NavLink>
                <NavLink to="/overseas">Overseas Clients</NavLink>
                <NavLink to="/internships">Internships</NavLink>
                <NavLink to="/new-office">New Office</NavLink>
                <NavLink to="/articles">Articles</NavLink>
                <NavLink to="/contact">Contact</NavLink>
              </nav>
            </div>
            <div className="footer-col">
              <p className="footer-heading">Contact</p>
              <a className="footer-link" href="tel:+923343161041">+92 334 316 1041</a>
              <a className="footer-link" href="tel:+923343161042">+92 334 316 1042</a>
              <a className="footer-link" href="https://wa.me/923343161042" target="_blank" rel="noopener noreferrer">WhatsApp Consultation</a>
              <a className="footer-link" href="mailto:irfanharoon@irfanharoonassociates.com">irfanharoon@irfanharoonassociates.com</a>
            </div>
            <div className="footer-col">
              <p className="footer-heading">Offices</p>
              <p className="footer-address">Floor 3, Building 1C, Lane 6,<br />Bukhari Commercial, DHA Phase 6, Karachi</p>
              <p className="footer-address">E 13 B, Lane No 3, Gulistan-E-Zafar,<br />Sindhi Muslim Society Block B, Karachi</p>
              <p className="footer-address">504 Paradise Chambers,<br />Near Passport Office, Saddar, Karachi</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>© 2025 Irfan Haroon &amp; Associates. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
